import { FunctionalComponent, h } from '@stencil/core';

interface TimerAnimationProps {
  duration: number;
}

export const TimerAnimation: FunctionalComponent<TimerAnimationProps> = ({ duration }) => {
  const rest = duration - 1280; // Total duration - 640ms - 640ms
  return (
    <div class="pie">
      <div class="slice spinner" style={{ animationDuration: `640ms, 640ms, ${rest}ms` }} />
      <div class="slice filler" style={{ animationDuration: `640ms, 640ms, ${rest}ms` }} />
      <div class="mask spinner" style={{ animationDuration: '640ms' }}>
        <div class="inner" />
      </div>
      <div class="mask filler" style={{ animationDuration: `${rest}ms` }}>
        <div class="inner" />
      </div>
    </div>
  );
};
